<template>
<aside class="menu">
  <p class="menu-label">
    Management Console
  </p>
  <ul class="menu-list">
    <li><router-link to="/admin/applications">Applicants</router-link></li>
    <li><router-link to="/admin/companies">Companies</router-link></li>
    <li><router-link to="/admin/jobs">Jobs</router-link></li>
    <li v-if="user && user.isAdmin"><router-link to="/admin/hirers">Hirers</router-link></li>
  </ul>
</aside>
</template>

<script>
import {mapState} from 'vuex'
export default {
  computed: {
    ...mapState('users', ['user'])
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
aside {
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
  height: calc(100vh - #{$navbar-height});
  background-color: white;
  margin-top: -1.5rem;
  padding-top: 1rem;
  margin-bottom: -1rem;
}

.menu-label {
  padding-left: 1rem;
}
.menu-list > li a {
  padding-left: 2rem;
  padding-right: 2rem;
}

@media screen and (max-width: $tablet) {
  aside {
    height: 5rem;
  }
  .menu-label:not(:last-child) {
    margin-bottom: .4rem;
  }
  .menu-list li {
    display: inline-block;
    padding-left: .6rem;
  }
  .menu-list > li a {
    padding-left: .3rem;
    padding-right: .3rem;
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/menu.vue